export const PROVIDERS = {
  GOOGLE_PLAY: 'GOOGLE_PLAY',
};

/**
 * @typedef {Object} SubscriptionPurchase
 * @property {string} purchaseToken
 * @property {string} productId
 * @property {string} [orderId]
 * @property {'ACTIVE'|'PENDING'|'CANCELLED'} [status]
 */

/**
 * @typedef {Object} PaymentProvider
 * @property {(productId: string) => Promise<{ success: boolean, purchase?: SubscriptionPurchase, message?: string }>} startSubscription
 * @property {() => Promise<{ success: boolean, purchases?: SubscriptionPurchase[], message?: string }>} restorePurchases
 */
